import React, { useMemo } from 'react'
import Dropdown from 'core/elements/dropdown'
import withProgress from 'core/components/progress/withProgress'
import useListAction from 'core/hooks/useListAction'
import { listStoragePools } from './actions'
import { useSelector } from 'react-redux'
import { storagePoolsSelector } from './selectors'
import { listResmgrHosts } from 'openstack/components/infrastructure/actions'
import { resmgrHostsSelector } from 'openstack/components/infrastructure/selectors'

const AsyncDropdown = withProgress(Dropdown, { inline: true })

export default function storagePoolsPicklist({
  disabled = false,
  name = 'storagePools',
  label = 'Storage Backends',
  includeNoneOption = false,
  filterFn = null,
  ...rest
}) {
  const { loading } = useListAction(listStoragePools)
  const storagePools = useSelector(storagePoolsSelector)

  const { loading: loadingHosts } = useListAction(listResmgrHosts)
  const hosts = useSelector(resmgrHostsSelector)

  const options = useMemo(() => {
    const hostNamesById = hosts.reduce(
      (accum, host) => ({
        ...accum,
        [host.id]: host.name || host.id,
      }),
      {},
    )
    const storagePoolOptions = storagePools.map((storagePool) => {
      const withoutPoolName = storagePool?.name?.split('#')?.[0]
      const [hostId, backend] = withoutPoolName?.split('@')
      return {
        label: `Host ${hostNamesById[hostId]} on backend ${backend}`,
        value: storagePool.name,
      }
    })
    const filteredOptions = filterFn ? filterFn(storagePoolOptions) : storagePoolOptions
    return includeNoneOption ? [{ label: 'None', value: '' }, ...filteredOptions] : filteredOptions
  }, [storagePools, hosts, includeNoneOption, filterFn])

  return (
    <AsyncDropdown
      {...rest}
      name={name}
      label={label}
      compact={false}
      disabled={disabled}
      loading={loading || loadingHosts}
      items={options}
    />
  )
}
